import { ControlButtonText } from "@nice-ccf/agent-sdk";

export interface ContactControlButtonProps {
  isVisible: boolean;
  isEnable: boolean;
  controlText: ControlButtonText;
}
